import { render, staticRenderFns } from "./MenuGauche.vue?vue&type=template&id=6cb8e3ac&scoped=true&"
import script from "./MenuGauche.vue?vue&type=script&lang=js&"
export * from "./MenuGauche.vue?vue&type=script&lang=js&"
import style0 from "./MenuGauche.vue?vue&type=style&index=0&id=6cb8e3ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb8e3ac",
  null
  
)

export default component.exports